import React from 'react';
import AccessControl, {SUPER_ADMIN_ROLE} from 'pwm-shared/dist/AccessControl'
import {useAuth} from 'src/PWM/hooks/use-auth';
import {useToast} from '../hooks/use-toast';
import {useRouter} from '../hooks/use-router';

const RoleGuard: React.FC<IRoleGuardProps> = (props) => {
  const {allowedRoles, redirectTo, message, children, ...rest} = props;

  const {account} = useAuth();
  const toast = useToast();
  const router = useRouter();

  if (allowedRoles instanceof Function) {
    if (!account) return null;
    const goForSuperAdmin = account.role === SUPER_ADMIN_ROLE;

    const goForUserPermission = AccessControl.hasRolePermissions(account.userRoles, allowedRoles());
    console.log(`User Can Access: ${goForSuperAdmin || goForUserPermission} ${allowedRoles().join(', ')}.`);
    const go = goForSuperAdmin || goForUserPermission;
    if (!go && redirectTo) {
      toast.error(message || 'You are not authorized to access this page!');
      return router.replace(redirectTo || '/');
    }
    if (go) {
      return React.Children.map(children, (component) => {
        if (React.isValidElement(component)) {
          return React.cloneElement(component, {...rest});
        } else {
          return component;
        }
      });
    }
  }
  return null;
};

export default RoleGuard;

export interface IRoleGuardProps {
  allowedRoles(): string[];
  message?: string;
  redirectTo?: string;
  children?: any;
}